
import { Expense, Currency } from '../types';

/**
 * Parses a CSV string into Expense objects.
 * Expects 5 columns: Date, Description, Currency, Amount, Category.
 */
export const parseExpenseCSV = (csvString: string): Promise<Expense[]> => {
  return new Promise((resolve, reject) => {
    const lines = csvString.split('\n').filter(l => l.trim() !== '');
    if (lines.length < 2) {
      resolve([]);
      return;
    }

    const rows = lines.slice(1);
    // Explicitly define return type for map to avoid overly specific type inference that conflicts with the subsequent filter predicate on line 56
    const expenses: Expense[] = rows.map((line, index): Expense | null => {
      const parts = line.split(',').map(p => p.trim());
      
      // Supporting old 4-column format or new 5-column format
      if (parts.length < 4) {
        console.warn(`Row ${index + 2} has invalid column count. Skipping.`);
        return null;
      }

      const date = parts[0];
      const description = parts[1];
      let currency: Currency = Currency.USD;
      let amountStr: string;
      let category: string;

      if (parts.length >= 5) {
        currency = (Object.values(Currency).includes(parts[2] as Currency)) ? (parts[2] as Currency) : Currency.USD;
        amountStr = parts[3];
        category = parts[4];
      } else {
        amountStr = parts[2];
        category = parts[3];
      }

      const amount = parseFloat(amountStr);

      if (isNaN(amount)) {
        console.warn(`Row ${index + 2} has invalid amount: ${amountStr}. Skipping.`);
        return null;
      }

      return {
        id: `csv-${Date.now()}-${index}`,
        date,
        description,
        amount,
        category,
        currency
      };
    }).filter((e): e is Expense => e !== null);

    resolve(expenses);
  });
};
